module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./HotSaleListView.js"));
	}, "HotSaleListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=HotSaleListView!./src/pages/PunchClock/Bean/HotSaleList/HotSaleListView.js
// module id = 1260
// module chunks = 438